import { Box, Icon, IconButton, Typography } from "@mui/material";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { DialogContext } from "../../../contexts/DialogueContext";
import { RootState } from "../../../slices/Store";

// updated
export default function ProjectDetailMobileHeader() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const projectDetail = projectDetailState.projectDetail;

    const { closeDialog } = useContext(DialogContext);

    const handleCloseDialog = () => {
        closeDialog();
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
                bgcolor: "background.paper",
                px: 2,
                py: 1.5,
                gap: 1,
            }}
        >
            <Typography fontSize="medium" color="primary">
                {projectDetail.hashId}
            </Typography>

            <Box sx={{ flexGrow: 1 }} />

            <IconButton sx={{ ml: 1 }} onClick={handleCloseDialog}>
                <Icon>close</Icon>
            </IconButton>
        </Box>
    );
}
